import { useLanguage } from '../contexts/LanguageContext'
import { useMemo } from 'react'
import translations from '../locales/translations'
import { getImageDimensions } from '../utils/imageDimensions'

const References = () => {
  const { language } = useLanguage()
  
  const pageContent = useMemo(() => {
    return (translations as any)[language].references
  }, [language])
  
  const categories = useMemo(() => [
    pageContent.categories.all,
    pageContent.categories.shoeBag,
    pageContent.categories.babyKids,
    pageContent.categories.homeFurniture,
    pageContent.categories.food,
    pageContent.categories.service,
    pageContent.categories.personalCare,
    pageContent.categories.automotive,
    pageContent.categories.outdoor,
    pageContent.categories.marketplace,
    pageContent.categories.healthMedical,
    pageContent.categories.jewelry,
    pageContent.categories.textile,
    pageContent.categories.electronics
  ], [pageContent])

  const brands = [
    { name: 'Veela', image: '/images/brands/veela1.webp', category: pageContent.categories.personalCare },
    { name: 'Daphne Sandals', image: '/images/brands/daphnesandals.webp', category: pageContent.categories.shoeBag },
    { name: 'Referans 1', image: '/images/brands/ref1.webp', category: pageContent.categories.service },
    { name: 'Referans 2', image: '/images/brands/ref2.webp', category: pageContent.categories.service },
    { name: 'Referans 3', image: '/images/brands/ref3.webp', category: pageContent.categories.food },
    { name: 'Referans 4', image: '/images/brands/ref4.webp', category: pageContent.categories.service },
    { name: 'Referans 6', image: '/images/brands/ref6.webp', category: pageContent.categories.service },
    { name: 'Referans 7', image: '/images/brands/ref7.webp', category: pageContent.categories.service },
    { name: 'Referans 8', image: '/images/brands/ref8.webp', category: pageContent.categories.service },
    // Duplicate for grid completion
    { name: 'Veela', image: '/images/brands/veela1.webp', category: pageContent.categories.personalCare },
    { name: 'Daphne Sandals', image: '/images/brands/daphnesandals.webp', category: pageContent.categories.shoeBag },
    { name: 'Referans 1', image: '/images/brands/ref1.webp', category: pageContent.categories.service },
    { name: 'Referans 2', image: '/images/brands/ref2.webp', category: pageContent.categories.service },
    { name: 'Referans 3', image: '/images/brands/ref3.webp', category: pageContent.categories.food },
    { name: 'Referans 4', image: '/images/brands/ref4.webp', category: pageContent.categories.service },
    { name: 'Referans 6', image: '/images/brands/ref6.webp', category: pageContent.categories.service },
    { name: 'Referans 7', image: '/images/brands/ref7.webp', category: pageContent.categories.service },
    { name: 'Referans 8', image: '/images/brands/ref8.webp', category: pageContent.categories.service },
  ]

  return (
    <div className="pt-16 bg-[#f9f9f9] relative min-h-screen">
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#e5e7eb_1px,transparent_1px),linear-gradient(to_bottom,#e5e7eb_1px,transparent_1px)] bg-[size:80px_80px] [mask-image:radial-gradient(ellipse_60%_40%_at_50%_10%,#000_20%,transparent_70%)] opacity-40 pointer-events-none"></div>
      
      {/* Hero Section */}
      <section className="py-24 relative">
        <div className="max-w-[1200px] mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="text-[28px] md:text-[44px] font-bold text-[#111] leading-tight mb-6">
              {pageContent.title}
            </h1>
            <p className="text-lg md:text-xl text-[#555] max-w-3xl mx-auto mb-8 leading-relaxed">
              {pageContent.subtitle}
            </p>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="pb-12 relative">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {categories.map((category, index) => (
              <button
                key={index}
                className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-200 ${
                  index === 0 
                    ? 'bg-[#d4fc3c] text-gray-900 hover:bg-[#c4ec2c]' 
                    : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Brands Grid */}
      <section className="pb-24 relative">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {brands.map((brand, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-lg transition-all duration-300 flex items-center justify-center min-h-[200px] group"
              >
                <img 
                  src={brand.image} 
                  alt={brand.name}
                  loading="lazy"
                  decoding="async"
                  width={getImageDimensions(brand.image)?.width}
                  height={getImageDimensions(brand.image)?.height}
                  className="max-w-full max-h-[80px] object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  )
}

export default References















